import React from 'react';
import styled from 'styled-components';
import { formatSaldo } from '../../utils/formatters';

const Card = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 1.5rem;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.shadows.soft};
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
`;
const CardTitle = styled.h3`
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.textSecondary};
`;
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
const Row = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.25rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  font-size: 0.85rem;
  cursor: pointer;
  &:last-child { border-bottom: none; }
  &:hover { background-color: ${props => props.theme.colors.background}; }
`;
const Nombre = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Saldo = styled.span`
  font-weight: 700;
  color: ${props => props.color};
  white-space: nowrap;
`;
const EmptyText = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: ${props => props.theme.colors.textSecondary};
`;

const TopClientesCard = ({ titulo, entries, currency, color, emptyText, onSelect }) => {
  const format = (value) => formatSaldo(value, currency);
  return (
    <Card>
      <CardTitle>{titulo}</CardTitle>
      {entries.length === 0 ? (
        <EmptyText>{emptyText}</EmptyText>
      ) : (
        <List>
          {entries.map(entry => (
            <Row
              key={entry.nroComitente}
              onClick={() => onSelect(entry)}
              title="Click para ver desglose"
            >
              <Nombre>{entry.nombre}</Nombre>
              <Saldo color={color}>{format(entry.saldoReal)}</Saldo>
            </Row>
          ))}
        </List>
      )}
    </Card>
  );
};

export default TopClientesCard;
